import { useEffect, type ReactNode } from 'react';

// Shared pieces of the designed sales pages (call guide, demo script): their own look (styles.css, "Call guide").

/** A part to replace before the call or the meeting. */
export const Ph = ({ children }: { children: ReactNode }) => <mark className="cg-ph">{children}</mark>;

/** What to say, close to word for word. */
export const Say = ({ children }: { children: ReactNode }) => <blockquote className="cg-say">{children}</blockquote>;

/** The pages have their own background (teal tint), as they were designed. */
export function useSalesPageBackground() {
  useEffect(() => {
    document.body.classList.add('cg-page');
    return () => document.body.classList.remove('cg-page');
  }, []);
}

/** The sticky bar of section links. */
export function SectionBar({ sections }: { sections: [string, string][] }) {
  return (
    <nav className="cg-bar" aria-label="Sections">
      {sections.map(([id, label]) => (
        <a key={id} href={`#${id}`}>
          {label}
        </a>
      ))}
    </nav>
  );
}
